<template>
  <section class="registerUser">
    <div class="registerUser__types">
      <h1>Cadastrar Pessoa</h1>

      <!-- <div class="registerUser__tabs">
        <button
          class="registerUser__tablinks"
          @click="openFormRegister('fisica')"
        >
          <i class="fas fa-user"></i>
          Física
        </button>
        <button
          class="registerUser__tablinks"
          @click="openFormRegister('juridica')"
        >
          <i class="fas fa-user-tie"></i>
          Júridica
        </button>
        <button
          class="registerUser__tablinks"
          @click="openFormRegister('colaborador')"
        >
          <i class="fas fa-users"></i>
          Colaborador
        </button>
      </div> -->

      <div id="fisica" class="registerUser__tabcontent">
        <!-- <p>Você está cadastrando: <span>Pessoa Física</span></p> -->
        <div action="" class="registerUser__dadosPessoais">
          <h3>DADOS PESSOAIS</h3>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Código do Cliente</label>
                <input class="input" type="text" disabled />
              </div>
              <div class="cols">
                <label class="label" for="">{{ pessoaFisica ? 'CPF' : 'CNPJ' }}</label>
                <the-mask class="input" type="text" :mask="pessoaFisica ? ['###.###.###-##'] : ['##.###.###/####-##']" v-model="cliente.cpfcnpj" @change.native="buscaCliente()" @keyup.native="verificaPessoa()"/>
              </div>
              <div class="cols">
                <label class="label" for="">{{ pessoaFisica ? 'Nome Completo' : 'Razão Social' }}</label>
                <input class="input" maxlength="60" type="text" v-model="cliente.nmcliente_razao"/>
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols" v-if="pessoaFisica">
                <label class="label" for="">RG</label>
                <input class="input" type="text" maxlength="14" v-model="cliente.rg"/>
              </div>
              <div class="cols" v-else>
                <label class="label" for="">Nome Fantasia</label>
                <input class="input" maxlength="60" type="text" v-model="cliente.nmfantazia"/>
              </div>
              <div class="cols">
                <label class="label" for="">{{ pessoaFisica ? 'Data de Nascimento' : 'Data de Fundação' }}</label>
                <input class="input" type="date" v-model="cliente.dtNascimentoFundacao"/>
              </div>
              <div class="cols" v-if="pessoaFisica">
                <label class="label" for="">Gênero</label>
                <select class="input" v-model="cliente.sexo">
                  <option value="">Selecione...</option>
                  <option value="F">Feminino</option>
                  <option value="M">Masculino</option>
                </select>
              </div>
              <div class="cols" v-else>
                <div class="rows" style="padding: 0px">
                  <div class="cols" style="width: auto;">
                    <label class="label" for="">Isento</label>
                    <div style="padding: 5px; margin: 0px 10px;">
                      <input class="input checkColor" style="align-self: center; transform: scale(1.5); margin-top: 5px;" type="checkbox" v-model="isento" @change="validaInscricao()"/>
                    </div>
                  </div>
                  <div class="cols" style="width: 100%;">
                    <label class="label" for="">Inscrição Estadual</label>
                    <the-mask v-if="!isento" class="input" type="text" :mask="'##############'" v-model="cliente.inscricao" :disabled="isento"/>
                    <input v-else class="input" type="text" v-model="cliente.inscricao" :disabled="isento"/>
                  </div>
                </div>
              </div>
              <!-- <div class="cols">
                <label class="label" for="">Orgão Emissor</label>
                <input class="input" type="text" v-model="cliente.rg"/>
              </div>
              <div class="cols">
                <label class="label" for="">Data de Expedição</label>
                <input class="input" type="date" v-model="cliente.rg"/>
              </div> -->
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">

              <div class="cols">
                <label class="label" for="">E-mail</label>
                <input class="input" maxlength="80" type="email" v-model="cliente.email"/>
              </div>
              <div class="cols" v-if="pessoaFisica">
                <div class="rows" style="padding: 0px">
                  <div class="cols" style="width: auto;">
                    <label class="label" for="">Isento</label>
                    <div style="padding: 5px; margin: 0px 10px;">
                      <input class="input checkColor" style="align-self: center; transform: scale(1.5); margin-top: 5px;" type="checkbox" v-model="isento" @change="validaInscricao()"/>
                    </div>
                  </div>
                  <div class="cols" style="width: 100%;">
                    <label class="label" for="">Inscrição Estadual</label>
                    <the-mask v-if="!isento" class="input" type="text" :mask="'##############'" v-model="cliente.inscricao" :disabled="isento"/>
                    <input v-else class="input" type="text" v-model="cliente.inscricao" :disabled="isento"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Acesso Plataforma</label>
                <input class="input" type="text" placeholder="S ou N" />
              </div>
              <div class="cols">
                <label class="label" for="">Tipo de Parceiro</label>
                <select class="input">
                  <option value="">Selecione...</option>
                  <option value="">Instalador</option>
                  <option value="">Instalador Solar</option>
                  <option value="">Instalador Solar</option>
                  <option value="">Revenda</option>
                  <option value="">Revenda Solar</option>
                  <option value="">Engenheiro / Arquiteto</option>
                  <option value="">Construtora</option>
                  <option value="">Outros</option>
                </select>
              </div>
              <div class="cols">
                <label class="label" for="">Número do CREA</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div> -->

          <!-- <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Código SAP</label>
                <input class="input" type="text" disabled />
              </div>
              <div class="cols">
                <label class="label" for="">Pedido Global</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div> -->
          <!-- <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">É Parceiro?</label>
                <input class="input" type="checkbox" />
              </div>
              <div class="cols">
                <label class="label" for="">Gestão Automática de Acesso?</label>
                <input class="input" type="checkbox" />
              </div>
            </div>
          </div> -->
          <button class="button" @click="salvarDados()">Salvar Dados</button>
        </div>
      </div>

      <div id="juridica" class="registerUser__tabcontent">
        <p>Você está cadastrando: <span>Pessoa Jurídica</span></p>
        <form action="" class="registerUser__dadosPessoais">
          <h3>DADOS PESSOAIS</h3>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Código do Cliente</label>
                <input class="input" type="text" disabled />
              </div>
              <div class="cols">
                <label class="label" for="">CNPJ</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Razão Social</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Nome Fantasia</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Data de Fundação</label>
                <input class="input" type="date" />
              </div>
              <div class="cols">
                <label class="label" for="">E-mail</label>
                <input class="input" type="email" />
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Acesso Plataforma</label>
                <input class="input" type="text" placeholder="S ou N" />
              </div>
              <div class="cols">
                <label class="label" for="">Tipo de Parceiro</label>
                <select class="input">
                  <option value="">Selecione...</option>
                  <option value="">Instalador</option>
                  <option value="">Instalador Solar</option>
                  <option value="">Instalador Solar</option>
                  <option value="">Revenda</option>
                  <option value="">Revenda Solar</option>
                  <option value="">Engenheiro / Arquiteto</option>
                  <option value="">Construtora</option>
                  <option value="">Outros</option>
                </select>
              </div>
              <div class="cols">
                <label class="label" for="">Número do CREA</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div>

          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Código SAP</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Pedido Global</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Inscrição Estadual</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Inscrição Estadual Isento?</label>
                <input class="input" type="checkbox" />
              </div>
              <div class="cols">
                <label class="label" for="">É Parceiro?</label>
                <input class="input" type="checkbox" />
              </div>
              <div class="cols">
                <label class="label" for="">Gestão Automática de Acesso?</label>
                <input class="input" type="checkbox" />
              </div>
            </div>
          </div>
          <button class="button">Salvar Dados</button>
        </form>
      </div>

      <div id="colaborador" class="registerUser__tabcontent">
        <p>Você está cadastrando: <span>Colaborador</span></p>
        <form action="" class="registerUser__dadosPessoais">
          <h3>DADOS PESSOAIS</h3>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Código do Cliente</label>
                <input class="input" type="text" disabled />
              </div>
              <div class="cols">
                <label class="label" for="">CPF</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Nome Completo</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">RG</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Orgão Emissor</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Data de Expedição</label>
                <input class="input" type="date" />
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Data de Nascimento</label>
                <input class="input" type="date" />
              </div>
              <div class="cols">
                <label class="label" for="">E-mail</label>
                <input class="input" type="email" />
              </div>
              <div class="cols">
                <label class="label" for="">Gênero</label>
                <select class="input">
                  <option value="">Selecione...</option>
                  <option value="">Feminino</option>
                  <option value="">Masculino</option>
                </select>
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Acesso Plataforma</label>
                <input class="input" type="text" placeholder="S ou N" />
              </div>
              <div class="cols">
                <label class="label" for="">Tipo de Parceiro</label>
                <select class="input">
                  <option value="">Selecione...</option>
                  <option value="">Instalador</option>
                  <option value="">Instalador Solar</option>
                  <option value="">Instalador Solar</option>
                  <option value="">Revenda</option>
                  <option value="">Revenda Solar</option>
                  <option value="">Engenheiro / Arquiteto</option>
                  <option value="">Construtora</option>
                  <option value="">Outros</option>
                </select>
              </div>
              <div class="cols">
                <label class="label" for="">Número do CREA</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div>

          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Código SAP</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Pedido Global</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">É Parceiro?</label>
                <input class="input" type="checkbox" />
              </div>
              <div class="cols">
                <label class="label" for="">Gestão Automática de Acesso?</label>
                <input class="input" type="checkbox" />
              </div>
            </div>
          </div>
          <button class="button">Salvar Dados</button>
        </form>
      </div>

      <div class="options">
        <!-- <div class="options__title" @click="upload = !upload">
          <h3>UPLOAD DE ARQUIVOS</h3>
        </div>
        <form action="" class="options__form" v-if="upload">
                <input class="input" type="file"/><br />
                <button class="button">Salvar Arquivo</button>
        </form> -->

        <div class="options__title" @click="endereco = !endereco">
          <h3>CADASTRO DE ENDEREÇO</h3>
        </div>
        <div class="options__form" v-if="endereco">
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">CEP</label>
                <the-mask class="input" :mask="['#####-###']" type="text" @change.native="buscaCEP()" v-model="novoEndereco.cep"/>
              </div>
              <div class="cols">
                <label class="label" for="">Rua</label>
                <input class="input" maxlength="120" type="text" v-model="novoEndereco.logradouro"/>
              </div>
              <div class="cols">
                <label class="label" for="">Número</label>
                <input class="input" maxlength="15" type="text" v-model="novoEndereco.nrresidencia"/>
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Bairro</label>
                <input class="input" maxlength="60" type="text" v-model="novoEndereco.bairro"/>
              </div>
              <div class="cols">
                <label class="label" for="">Complemento</label>
                <input class="input" maxlength="60" type="text" v-model="novoEndereco.complemento"/>
              </div>
              <div class="cols">
                <label class="label" for="">Cidade</label>
                <input class="input" maxlength="60" type="text" v-model="novoEndereco.cidade"/>
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Estado</label>
                <select class="input" v-model="novoEndereco.uf">
                  <option value="">Selecione...</option>
                  <option :value="uf.sigla" v-for="(uf, index) of ufs" :key="index+'Uf'">{{ uf.sigla }}</option>
                </select>
              </div>
            </div>
          </div>
          <button class="button" @click="adicionaEndereco()">Adicionar Endereço</button>

          <div class="options__table" style="overflow-x: auto">
            <table>
              <thead>
                <tr>
                  <th>CEP</th>
                  <th>Rua</th>
                  <th>Número</th>
                  <th>Bairro</th>
                  <th>Complemento</th>
                  <th>Cidade</th>
                  <th>Estado</th>
                  <!-- <th>Faturamento</th>
                  <th>Marcar Faturamento</th> -->
                  <th>Remover</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(endereco, index) in cliente.endereco" :key="index + 'end'">
                  <td>{{ endereco.cep }}</td>
                  <td>{{ endereco.logradouro }}</td>
                  <td>{{ endereco.nrresidencia }}</td>
                  <td>{{ endereco.bairro }}</td>
                  <td>{{ endereco.complemento }}</td>
                  <td>{{ endereco.cidade }}</td>
                  <td>{{ endereco.uf }}</td>
                  <!-- <td>S</td>
                  <td><button>Selecionar Endereço como Faturamento</button></td>-->
                  <td><i class="fas fa-trash-alt" v-if="endereco.novo" @click="removeEndereco(index)"></i></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="options__title" @click="telefone = !telefone">
          <h3>CADASTRAR TELEFONE</h3>
        </div>

        <div class="options__form" v-if="telefone">
          <div class="rows" v-if="!pessoaFisica">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Setor</label>
								<select class="input" v-model="novoTelefone.Setor">
                  <option :value="setor.nome" v-for="(setor, index) of setores" :key="index">{{ setor.nome }}</option>
                </select>
                <!-- <input class="input" maxlength="80" type="text" v-model="novoTelefone.Setor"/> -->
              </div>
              <div class="cols">
                <label class="label" for="">E-mail</label>
								<input class="input" maxlength="80" type="email" v-model="novoTelefone.Email"/>
              </div>
              <!-- <div class="cols">
                <label class="label" for="">Observação</label>
                <input class="input" type="text" />
              </div> -->
            </div>
          </div>
					 <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">DDD</label>
                <the-mask class="input" type="text" :mask="['(##)']" v-model="novoTelefone.DDD"/>
              </div>
              <div class="cols">
                <label class="label" for="">Número</label>
                <the-mask class="input" :mask="['#####-####', '####-####']" type="text" v-model="novoTelefone.NRTelefone"/>
              </div>
              <!-- <div class="cols">
                <label class="label" for="">Observação</label>
                <input class="input" type="text" />
              </div> -->
            </div>
          </div>
          <button class="button" @click="adicionaTelefone()">Adicionar Telefone</button>

          <div class="options__table" style="overflow-x: auto">
            <table>
              <thead>
                <tr>
									<th>Setor</th>
									<th>Email</th>
                  <th>DDD</th>
                  <th>Número</th>
                  <!-- <th>Observação</th> -->
                  <th>Remover</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(tel, index) in cliente.telefone" :key="index + 'tel'">
                  <td>{{ tel.Setor }}</td>
									<td>{{ tel.Email }}</td>
									<td>{{ tel.DDD }}</td>
                  <td>{{ tel.NRTelefone }}</td>
                  <!-- <td></td> -->
                  <td><i class="fas fa-trash-alt" @click="removeTelefone(index)"></i></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- <div class="options__title" @click="banco = !banco">
          <h3>CADASTRAR DADOS BANCÁRIOS</h3>
        </div>

        <form action="" class="options__form" v-if="banco">
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Data Abertura</label>
                <input class="input" type="date" />
              </div>
              <div class="cols">
                <label class="label" for="">Nome do Banco</label>
                <select class="input">
                  <option value="">Selecione...</option>
                </select>
              </div>
              <div class="cols">
                <label class="label" for="">Código do Banco</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Agência</label>
                <input class="input" type="text" />
              </div>
              <div class="cols">
                <label class="label" for="">Dígito da Agência</label>
                <input type="text" class="input" />
              </div>
              <div class="cols">
                <label class="label" for="">Conta Corrente</label>
                <input class="input" type="text" />
              </div>
            </div>
          </div>
          <div class="rows">
            <div class="form-groups">
              <div class="cols">
                <label class="label" for="">Dígito da Conta Corrente</label>
                <input class="input small" type="text" />
              </div>
            </div>
          </div>
          <button class="button">Salvar Dados Bancários</button>
        </form> -->
      </div>
    </div>
    <v-app>
      <v-dialog
        v-model="loading"
        persistent
        width="300"
      >
        <v-card
          color="var(--standardGreen)"
          dark
        >
          <v-card-text style="padding: 27px;" >
            {{ mensagemLoading }}
            <v-progress-linear
              style="margin-top: 15px"
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-app>
  </section>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      upload: false,
      endereco: false,
      telefone: false,
      banco: false,
      user: null,
      isento: false,
      loading: false,
      mensagemLoading: null,
      pessoaFisica: true,
      cliente: {
        cpfcnpj: null,
        rg: null,
        nmcliente_razao: null,
        dtNascimentoFundacao: null,
        dtCadastro: null,
        sexo: null,
        tpPessoa: null,
        nmfantazia: null,
        inscricao: null,
        email: null,
        email_boleto: null,
        usuarioAlteracao: null,
        endereco: [],
        telefone: []
      },
      novoTelefone: {
        DDD: null,
        NRTelefone: null,
				Setor: null,
				Email: null
      },
      novoEndereco: {
        logradouro: null,
        nrresidencia: null,
        complemento: null,
        bairro: null,
        cidade: null,
        uf: null,
        cep: null,
        Pais: null
      },
			setores: [
				{
					nome: "Compras"
				},
				{
					nome: "Financeiro"
				},
				{
					nome: "Logística"
				}
			],
      ufs: [
        { sigla: 'AC' },
        { sigla: 'AL' },
        { sigla: 'AP' },
        { sigla: 'AM' },
        { sigla: 'BA' },
        { sigla: 'CE' },
        { sigla: 'DF' },
        { sigla: 'ES' },
        { sigla: 'GO' },
        { sigla: 'MA' },
        { sigla: 'MT' },
        { sigla: 'MS' },
        { sigla: 'MG' },
        { sigla: 'PA' },
        { sigla: 'PB' },
        { sigla: 'PR' },
        { sigla: 'PE' },
        { sigla: 'PI' },
        { sigla: 'RJ' },
        { sigla: 'RN' },
        { sigla: 'RS' },
        { sigla: 'RO' },
        { sigla: 'RR' },
        { sigla: 'SC' },
        { sigla: 'SP' },
        { sigla: 'SE' },
        { sigla: 'TO' }
      ]
    };
  },
  methods: {
    openFormRegister(type) {
      let i, tabcontent;
      tabcontent = document.getElementsByClassName("registerUser__tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      document.getElementById(type).style.display = "block";
    },

    buscaCliente(doc = null) {
			console.log(this.pessoaFisica);
			console.log(doc);
			if(this.pessoaFisica == false && doc == null){
				console.log(this.cliente.cpfcnpj);
				if(this.cliente.cpfcnpj.length <= 12){
					alert('Documento incorreto');
					return;
				}
			}
      this.cliente.cpfcnpj = doc ? doc : this.cliente.cpfcnpj;
      this.mensagemLoading = 'Buscando dados, por favor aguarde...';
      this.loading = true;
      axios.get(`https://www.leverosintegra.com.br/Map/api/Client/${this.cliente.cpfcnpj}?token=${this.user.token}`)
      .then(res => {
        if (res.data.Dados) {
          let Cliente = res.data.Dados;
          this.cliente = Cliente;

          // Verifica se o cliente é PJ
          if (this.cliente.cpfcnpj > 11) {
            // Realiza tratativa de inscrição estadual
            this.isento = this.cliente.inscricao === 'ISENTO' || this.cliente.inscricao === 'ISENTO ' ? true : false;
          }
          this.cliente.dtNascimentoFundacao = this.moment(this.cliente.dtNascimentoFundacao).format("YYYY-MM-DD")
          this.loading = false;
        } else {
          this.limpaDados();
          this.loading = false;
        }
      }).catch(err => {
        console.log(err.response);
        this.limpaDados();
        this.loading = false;
      })
    },

    validaInscricao() {
      if (this.isento) {
        this.cliente.inscricao = 'ISENTO';
      } else {
        this.cliente.inscricao = '';
      }
    },

    buscaCEP() {
      axios.get(`https://viacep.com.br/ws/${this.novoEndereco.cep}/json/`)
      .then(res => {
        let Endereco = res.data;
        this.novoEndereco.logradouro = Endereco.logradouro
        this.novoEndereco.cidade = Endereco.localidade
        this.novoEndereco.uf = Endereco.uf
        this.novoEndereco.bairro = Endereco.bairro
      }).catch(err => {
        console.log(err)
      })
    },

    adicionaTelefone() {
      if (this.novoTelefone.DDD && this.novoTelefone.NRTelefone) {
        let telefone =  Object.assign({}, this.novoTelefone);
        telefone.novo = true;
        this.cliente.telefone.push(telefone);
        this.limpaDadosTelefone();
      } else {
        alert("Não foi possivel inserir novo telefone! Verifique os dados!")
      }
    },

    adicionaEndereco() {
      if (this.novoEndereco.cep && this.novoEndereco.logradouro && this.novoEndereco.nrresidencia && this.novoEndereco.bairro &&
          this.novoEndereco.cidade && this.novoEndereco.uf) {
        let endereco =  Object.assign({}, this.novoEndereco);
        endereco.bairro = endereco.bairro.toUpperCase();
        endereco.logradouro = endereco.logradouro.toUpperCase();
        endereco.nrresidencia = endereco.nrresidencia.toUpperCase();
        endereco.complemento = endereco.complemento ? endereco.complemento.toUpperCase() : null;
        endereco.cidade = endereco.cidade.toUpperCase();
        endereco.Pais = 1;
        endereco.novo = true;
        this.cliente.endereco.push(endereco);
        this.limpaDadosEndereco();
      } else {
        alert("Não foi possivel inserir novo endereço! Verifique os dados!")
      }
    },

    salvarDados() {
      this.cliente.usuarioAlteracao = this.user.nomeUsuario ? this.user.nomeUsuario : null;
      this.cliente.nmcliente_razao = this.cliente.nmcliente_razao ? this.cliente.nmcliente_razao.toUpperCase() : null;
      this.cliente.nmfantazia = this.cliente.nmfantazia ? this.cliente.nmfantazia.toUpperCase() : null;
      this.cliente.email = this.cliente.email ? this.cliente.email.toUpperCase() : null;

      if (!this.cliente.nmcliente_razao || !this.cliente.cpfcnpj) {
        return alert("Ops... \n\nDados incompletos, por favor verifique!")
      }
        if (!this.cliente.email){
        return alert("Ops... \n\nE-mail não preenchido, por favor verifique!")
      }
      else {
           var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(this.cliente.email)) {
              return alert("Ops... \n\nE-mail inválido, por favor verifique!")
            }
      }

      // Valida preenchimento de telefone
      if (this.cliente.telefone.length === 0) {
        return alert("Ops... \n\nO cliente deve ter ao menos um telefone cadastrado!")
      }

      // Valida preenchimento de endereco
      if (this.cliente.endereco.length === 0) {
        return alert("Ops... \n\nO cliente deve ter ao menos um endereço cadastrado!")
      }

      let body = {
        Dados: this.cliente
      }

      this.mensagemLoading = 'Salvando dados, por favor aguarde...';
      this.loading = true;
      axios({
        method: "post",
        data: body,
        url: `https://www.leverosintegra.com.br/Map/api/Client?token=${this.user.token}`,
      }).then(res => {
        this.loading = false;
        if (res.data) {
          alert("Dados salvos com sucesso!");
          this.buscaCliente(this.cliente.cpfcnpj);
        }

      }).catch(err => {
        this.loading = false;
        console.log(err);
      })
    },

    removeTelefone(index) {
      this.cliente.telefone.splice(index, 1);
    },

    removeEndereco(index) {
      this.cliente.endereco.splice(index, 1);
    },

    limpaDadosTelefone() {
      this.novoTelefone.DDD = null;
      this.novoTelefone.NRTelefone = null;
			this.novoTelefone.Setor = null;
			this.novoTelefone.Email = null;
    },

    limpaDadosEndereco() {
      this.novoEndereco.logradouro = null;
      this.novoEndereco.nrresidencia = null;
      this.novoEndereco.complemento = null;
      this.novoEndereco.bairro = null;
      this.novoEndereco.cidade = null;
      this.novoEndereco.uf = null;
      this.novoEndereco.Pais = null;
      this.novoEndereco.cep = null;
    },

    limpaDados() {
      // this.cliente.cpfcnpj = null;
      this.cliente.rg = null;
      this.cliente.nmcliente_razao = null;
      this.cliente.dtNascimentoFundacao = null;
      this.cliente.dtCadastro = null;
      this.cliente.sexo = null;
      this.cliente.tpPessoa = null;
      this.cliente.nmfantazia = null;
      this.cliente.inscricao = null;
      this.cliente.email = null;
      this.cliente.email_boleto = null;
      this.cliente.usuarioAlteracao = null;
      this.cliente.endereco = [];
      this.cliente.telefone = [];
    },

    verificaPessoa() {
      // this.pessoaFisica = this.cliente.cpfcnpj.length > 11 ? false : true;
    }

  },
  created() {
		console.log(this.$route.query.tp)
		if(this.$route.query.tp == "fisica"){
			this.pessoaFisica = true;
		}
		else{
			this.pessoaFisica = false;
		}

    this.user = JSON.parse(localStorage.getItem("login"));
  },

};
</script>


<style lang="scss" scoped>
.registerUser {
  &__types {
    max-width: 90%;
    margin: 0 auto;
    padding: 50px 0;

    @media (max-width: 440px) {
      max-width: 95%;
    }

    h1 {
      color: #005a64;
      font-size: 1.25rem;
      margin-bottom: 30px;
    }

    h3 {
      color: #150d1c;
      font-size: 0.813rem;
      padding: 20px 0 10px 0;
    }
  }

  &__tabs {
    display: flex;
  }

  &__tablinks {
    background: #005a64;
    border-radius: 5px;
    padding: 10px;
    margin: 0 10px 0 0;
    color: #fff;
    font-size: 0.875rem;
    outline: none;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    letter-spacing: 0.0492857143rem;
    text-transform: uppercase;

    &:hover {
      background: #002d32;
    }
  }

  &__tabcontent {
    display: none;

    p {
      padding: 30px 0 10px 0;

      span {
        font-weight: bold;
      }
    }
  }

  &__dadosPessoais {
    border: 1px solid #d1d1d1;
    border-radius: 5px;
    margin-top: 20px;

    h3 {
      padding-left: 13px;
    }
  }

  .options {
    margin-top: 30px;

    &__title {
      border-bottom: 1px solid #d1d1d1;
      background: #d1d1d1;
      margin: 10px 0 0 0;
      cursor: pointer;

      h3 {
        padding-left: 10px;
      }
    }
    &__form {
      border-left: 1px solid #d1d1d1;
      border-right: 1px solid #d1d1d1;
      border-bottom: 1px solid #d1d1d1;
      border-radius: 0 0 5px 5px;
      padding: 15px 0 0 0;
    }

    &__table {
      padding: 30px 10px;

      table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;

        thead {
          tr {
            th {
              background: #ebebeb;
              padding: 10px;
              color: #424242;
              font-size: 0.875rem;
            }
          }
        }

        tbody {
          tr {
            td {
              padding: 9px;
              border-bottom: 1px solid #a1a1a1;
              text-align: center;
              font-size: 0.875rem;

              button {
                background: #6fffaf;
                color: #1d1d1d;
                padding: 4px;
                border-radius: 5px;
                outline: none;
                font-size: 0.875rem;
                box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
                  0px 2px 2px 0px rgb(0 0 0 / 14%),
                  0px 1px 5px 0px rgb(0 0 0 / 12%);
              }

              i {
                color: #b31313;
                font-size: 1rem;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #4d4d4d;
  }

  ::-webkit-scrollbar {
    height: 8px;
    background: #c5c5c5;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #6fffaf;
    border-radius: 10px;
  }
}

.rows {
  display: flex;
  padding: 5px 0;
}

.form-groups {
  display: flex;
  width: 100%;

  @media (max-width: 440px) {
    flex-direction: column;
  }
}

.cols {
  display: flex;
  flex-direction: column;
  width: 33%;

  @media (max-width: 440px) {
    width: 100%;
  }
}

.label {
  font-size: 0.75rem;
  padding: 10px;
}

.input {
  border: 1px solid #a1a1a1;
  border-radius: 5px;
  padding: 5px;
  margin: 0 10px;
  outline: none;
  font-size: 0.875rem;
  text-transform:uppercase
}

input[type="text"]:disabled {
  background: #e6e6e6;
}

.small {
  width: 10%;
}

.button {
  background: #005a64;
  color: #fff;
  border-radius: 5px;
  padding: 10px;
  margin: 20px 0 20px 10px;
  font-size: 0.875rem;
  outline: none;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
    0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  letter-spacing: 0.0492857143rem;
  text-transform: uppercase;
}

#fisica {
  display: block;
}

.checkColor { filter: hue-rotate(318deg) }
</style>
